// extracted by mini-css-extract-plugin
module.exports = {"Container":"Form_Container__1E_YT","Intro":"Form_Intro__2T_kp"};